import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from '../../../InputField';
import FormError from '../../../FormError';

let ChangeVoicemailPinModalForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <Field component={InputField} name="new_pin" label="New Pin" />
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Change Pin</button>
  </form>
);

ChangeVoicemailPinModalForm = reduxForm({
  form: 'voicemailPin',
})(ChangeVoicemailPinModalForm);

export default ChangeVoicemailPinModalForm;
